const logoContext =
    (require as any).context('../assets/images', false, /\.(jpg|jpeg|png)$/);

export function getCompanyLogoPath(companyId: string): string {
    try {
        return logoContext(`./${companyId}.jpg`);
    } catch {
        return logoContext('./logo_default.jpg');
    }
}
